module.exports = __webpack_public_path__ + "static/img/img_9.9b6a72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_9.png
// module id = LTSS
// module chunks = 169